import { ToastType } from "../models/toast.enum";

const DelayDefault:number = 3000;
const DelayDefaultError:number = 10000;
const DelayDefaultWarning:number = 10000;
const DelayDefaultInfo:number = 10000;

export const toastConfig_success_common = {
    type: ToastType.SUCCESS, 
    text: "", 
    classname: 'bg-success text-light', 
    delay: DelayDefault,
    sticky: false
}

export const toastConfig_error_common = {
    type: ToastType.ERROR, 
    text: "", 
    classname: 'bg-danger text-light', 
    delay: DelayDefaultError,
    sticky: true
}

export const toastConfig_warning_common = {
    type: ToastType.WARNING, 
    text: "", 
    classname: 'bg-warning text-light', 
    delay: DelayDefaultWarning,
    sticky: true
}

export const toastConfig_info_common = {
    type: ToastType.DEFAULT, 
    text: "", 
    classname: 'bg-info text-light', 
    delay: DelayDefaultInfo,
    sticky: false
}

export const toastConfig_messageresponse_delete = {
    success: { ...toastConfig_success_common, text: "Cancellazione completata" },
    error: { ...toastConfig_error_common, text: "Errore durante la cancellazione" }
};

export const toastConfig_messageresponse_evalute = {
    success: { ...toastConfig_success_common, text: "Rivalutazione inviata" },
    error: { ...toastConfig_error_common, text: "Errore durante la rivalutazione" }
};

export const  toastConfig_messageresponse_update = {
    success: { ...toastConfig_success_common,text: "Modifica completata"},
    error: { ...toastConfig_error_common, text: "Errore durante la modifica"}
};

export const  toastConfig_messageresponse_create = {
    success: { ...toastConfig_success_common,text: "Salvato con successo"},
    error: { ...toastConfig_error_common, text: "Errore durante il salvataggio"}
};

export const  toastConfig_messageresponse_retry = {
    success: { ...toastConfig_success_common,text: "Inviato con successo"},
    error: { ...toastConfig_error_common, text: "Errore durante l'invio"}
};

export const  toastConfig_messageresponse_urges = {
    success: { ...toastConfig_success_common,text: "Richiesta inviata"},
    error: { ...toastConfig_error_common, text: "Errore durante l'invio richiesta"}
};

export const  toastConfig_messageresponse_valida = {
    success: { ...toastConfig_success_common,text: "Validazione inviata"},
    error: { ...toastConfig_error_common, text: "Errore durante l'invio della validazione"}
};

export const  toastConfig_messageresponse_renewal = {
    success: { ...toastConfig_success_common,text: "Richiesta inviata"},
    error: { ...toastConfig_error_common, text: "Errore durante l'invio richiesta"}
};

export const  toastConfig_messageresponse_download = {
    success: { ...toastConfig_success_common,text: "Richiesta download inviata con successo"},
    error: { ...toastConfig_error_common, text: "Errore durante la richiesta di download"}
};

export const toastConfig_messageresponse_clone = {
    success: { ...toastConfig_success_common, text: "Clonazione completata" },
    error: { ...toastConfig_error_common, text: "Errore durante la clonazione" }
};